"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClasses = void 0;
const common_1 = require("@finley-technologies/common");
const getClasses = (classMechanics, borrowingBaseReport) => {
    const classes = [];
    // Classes are currently funded by referencing attachment rate limits
    // Resolved attachment rates contained in borrowing base report output is required
    // Attachment rates are defined as formulas, but resolved to a number in data pipeline
    (0, common_1.finleyAssert)(borrowingBaseReport.classDetails.classAttachmentLimits, `Calculated attachment rate limit values within borrowing base report are required for class handling within funding requests.`);
    const resolvedAttachmentRates = borrowingBaseReport.classDetails.classAttachmentLimits;
    classMechanics.classes.forEach((classDetail) => {
        const resolvedAttachmentRate = resolvedAttachmentRates.find(({ classLabel }) => classLabel === classDetail.classLabel.value);
        (0, common_1.finleyAssert)(resolvedAttachmentRate, `Calculated attachment rate limit for Class ${classDetail.classLabel.value} was not found within borrowing base report.`);
        classes.push({
            key: classDetail.classLabel.value,
            attachmentRate: resolvedAttachmentRate.attachmentRateLimit,
            lenderIds: classDetail.capitalProviders.map(({ entity }) => entity.id),
        });
    });
    return { classes };
};
exports.getClasses = getClasses;
//# sourceMappingURL=classes.js.map